import React from "react";
import Card from "../../CommonComponents/Card";
import Button from "../../CommonComponents/Button";
import HeadLines from "../../CommonComponents/HeadLines";
import style from "./../Commodities/style.module.css";
const FindNow = (props) => {
  const {
    title = "Finding a new Warehouse?",
    subTitle,
    buttonDisabled = false,
    className = `justify-content-center d-flex boxRadius8 ${style["backGrey"]} padding16 margin16 `,
    className2,
    buttonClassName = `${style["boxRadius6"]} margin-left16 mtb-auto padding-top8 padding-left8 padding-right8 padding-bottom8 backgroundWhite line-height16 font-size14 font-weight500 letterSpacing0125`,
    titleClassName = "padding-right4 textColorWhite font-size14 line-height16 letterSpacing05 font-weight400 padding-top16 padding-bottom16",
    subTitleClassName = "",
    buttonText = "Find Now",
    onClick = () => null,
    buttonParentClassName = "",
  } = props;

  return (
    <>
      <Card className={className}>
        <div className={className2}>
          {title && <HeadLines className={titleClassName} text={title} />}

          <HeadLines className={subTitleClassName} text={subTitle} />
        </div>
        <div className={buttonParentClassName}>
          <Button
            disabled={buttonDisabled}
            className={`${buttonClassName} colorDark5 `}
            title={buttonText}
            onClick={onClick}
          />
        </div>
      </Card>
    </>
  );
};
export default FindNow;
